import { crashNotification } from './crash-notification';
import { isBrowser } from 'app/infrastructure/universal';
import { fatal, error } from 'app/infrastructure/log';
import { isEdgeOnIos } from 'app/infrastructure/platform/browser';

let applicationDidMount = false;
let dispatch: (obj: {}) => void = null;

/**
 * Notify
 * 
 * >Dispatches a user notification to be displayed
 * 
 * In the case of type `ERROR`:
 * 
 *    -If application has rendered, dispatch an error action.
 *    -Otherwise trigger a panic bar.
 */
function notify(message: string, details?: string, type: string = 'ERROR'){
  
  if (applicationDidMount && !!message){
    dispatch({type, message, error: details });
    return;
  }
  
  // In case we are still in the critical startup execution phase
  if ( type === 'ERROR'){
    crashNotification(message, details);
  }

}

/**
 * Notify the user about a potentially recoverable error
 * 
 * >Dispatches a redux action to trigger the notification visually
 * 
 *    -If application has rendered at the time of the error, dispatch an error action.
 *    -Otherwise trigger a crash notification.
 */
export function notifyError(message: string, details?: string){
  notify(message, details, 'ERROR');
}

/**
 * Must be called by the application root component to signal that we are 
 * mounted and ready to notify users trough react and redux
 */
export function enableNotifications(element: any, dispatcher: any){
  applicationDidMount = true;
  dispatch = dispatcher;
}

/**
 * Offers a visual notification if anything fails during app startup
 */
export function enableStartupCrashNotifications() {
  if (!isBrowser){
    return (f: any) => f;
  }
  
  // Fix for iOS Edge specific bug appearing during login - #571028
  if (isEdgeOnIos) {
    window.onerror = console.error;
    
    return () => {
      window.onerror = console.error;
    };
  }

  window.onerror = fatal;
  return () => {
    // the critical path is now done, reset to default error behaviour    
    window.onerror = error;
  };
}
